

class PageNavigationController {
    constructor($state, LoadedModel, MenuElements) {
        this._MenuElements = MenuElements;
        this._LoadedModel = LoadedModel;
        this._$state = $state;
    }

    goNext() {
        this._$state.go(this.next);
    }

    goPrev() {
        this._$state.go(this.prev);
    }

    isStateEnabled(stateName) {
        return this._MenuElements.isStateEnabled(stateName);
    }
}

PageNavigationController.$inject = ['$state', 'LoadedModel', 'MenuElements'];

export default PageNavigationController;



// WEBPACK FOOTER //
// ./client/app/common/page-navigation/page-navigation.controller.js